import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {CdkConnectedOverlay, CdkOverlayOrigin, ConnectedPosition} from '@angular/cdk/overlay';
import {PillColor, PillFill, PillItem} from '../../../shared/models/pill';
import {PillComponent} from '../pill/pill.component';
import {ClickOutsideServiceDirective} from '../../directives/click-outside-service.directive';

const DEFAULT_OVERLAY_POSITIONS: ConnectedPosition[] = [
  {originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top',    offsetY:  4},
  {originX: 'start', originY: 'top',    overlayX: 'start', overlayY: 'bottom', offsetY: -4},
];

@Component({
  selector: 'motn-pill-list',
  templateUrl: './pill-list.component.html',
  styleUrls: ['./pill-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PillComponent,
    CdkOverlayOrigin,
    CdkConnectedOverlay,
    ClickOutsideServiceDirective,
  ],
})
export class PillListComponent {
  @Input() items: PillItem[] = [];
  @Input() maxVisible = 3;
  @Input() wrap = false;
  @Input() removable = false;
  @Input() color?: PillColor;
  @Input() fill: PillFill = 'outline';
  @Input() overlayPositions: ConnectedPosition[] = DEFAULT_OVERLAY_POSITIONS;
  @Output() remove = new EventEmitter<PillItem>();

  overlayOpen = false;

  get visibleItems(): PillItem[] { return this.items.slice(0, this.maxVisible); }
  get hiddenItems(): PillItem[]  { return this.items.slice(this.maxVisible); }
  get hiddenCount(): number      { return this.hiddenItems.length; }

  toggle(event: MouseEvent): void {
    event.stopPropagation();
    this.overlayOpen = !this.overlayOpen;
  }

  close(): void {
    this.overlayOpen = false;
  }
}
